export const tableColumns = [
    {
        Header: 'Discipline',
        accessor: 'discipline',
        width: 130,
    },
    {
        Header: 'Date',
        accessor: 'daily_date',
        width: 70,
        Cell: (cell) => {
            const row = cell.row.original;
            let dailyId = typeof row !== 'undefined' ? row.daily_id : null;
            return (
                <a
                  href={`/data_entry/daily/daily/edit/${dailyId}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                    <b>{cell.value}</b>
                </a>
              );
        }
    },
    {
        Header: 'Shift',
        accessor: 'daily_shift',
        width: 50,
    },
    {
        Header: 'Rig',
        accessor: 'rig_name',
        width: 60,
    },
    {
        Header: 'Client',
        accessor: 'client_name',
        width: 200,
    },
    {
        Header: 'Job',
        accessor: 'job_number',
        width: 85,
    },
    {
        Header: 'Toolpusher',
        accessor: 'created_by',
        width: 150,
    },
    {
        Header: 'Hours',
        accessor: 'hours',
        width: 50,
    },
    {
        Header: 'Description',
        accessor: 'description',
        width: 150,
    },
    {
        Header: 'Notes',
        accessor: 'daily_notes',
    },
    {
        Header: 'Comments',
        accessor: '',
        width: 1,
    },
];
